module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "cn",
    attrs: {
      "id": "Toc_Link1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_Toc_Link1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("CHAPTER 1")])])]), _vm._v(" "), _c('p', {
    staticClass: "ct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_Toc_Link1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Introduction")])])]), _vm._v(" "), _c('p', {
    staticClass: "co"
  }, [_vm._v("If you are reading this introduction then this book is probably not for you. This book is directed at calculus students who have better things to do with their time than read wordy preambles that won’t be on the exam. But just in case you haven’t actually bought this book yet and are considering a purchase while flipping through the pages in a bookstore, we’ll tell you what it’s all about.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("If you want to know the tricks of the trade that will make learning the material of first-semester calculus a piece of cake, then this is the book for you. If you want to learn lots of cool things while having a good time, then this is the book for you. If you want to carry around a book that makes people think you are surfing the wave of knowledge, then this is the book for you.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Do you remember being in a class and being hopelessly confused? Perhaps your attention wandered at some important moment, or the lecturer thoughtlessly slipped into ancient Greek when explaining the basic idea. After class, you asked your brainy friend over a cup of coffee, “What was going on in that class?” Your friend explained it all in five minutes flat and made it crystal clear. “Oh,” you said, “is that all there is to it? Why didn’t they just say that in the first place?” Later, you wished that friend was around to explain all the lectures to you.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("This book aims to play the role of your friend. It gives informal explanations of the key topics of calculus, getting across the ideas without the technical details and fine print that would be found in a formal text. This book does not substitute for a calculus textbook, but it should make it much easier to figure out what the textbook is talking about.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("If you approach it with the right point of view, learning calculus can be not only a mind-expanding experience but also fantastic fun, just about as good as something not involving whipped cream and maraschino cherries can get. This book is going to tell you how calculus is taught, how to get the best teachers, what to study, and what is likely to be on exams. This is the stuff we wish we’d known when we had to take calculus. So, enough stalling. Why don’t you go up to that nice cashier, plunk down some money and buy this book, and we can talk more after?")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f604df2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter1.vue
// module id = 69
// module chunks = 0